export default __webpack_public_path__ + "static/media/5.9dd06d1c.jpg";